<a class="avatar-container" [blogLink]="disabled() ? undefined : user()" [matTooltip]="user()?.url || ''">
  <div class="avatar" [style.background-image]="'url(' + avatar() + ')'"></div>
</a>
